function isPepper() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('pepper') !== -1;
}

export default isPepper;
